export default __webpack_public_path__ + "static/media/next-clicked-green.678ae053.svg";